import React from 'react'

import { ReactComponent as HandSetCallIcon } from 'assets/svg/shared/handsetcall.svg'

export function CallButton(props) {
    const { width = '60px', height = '60px', imgHeight = '28px', radius = '16px', onClick = () => {} } = props

    return (
        <button
            type="button"
            className="dialpad__call-btn d-flex justify-content-center align-items-center"
            style={{ width, height, borderRadius: radius }}
            onClick={onClick}
        >
            <HandSetCallIcon height={imgHeight} />
        </button>
    )
}
